import React from 'react';

const LoadingSpinner = () => (
  <div className="min-h-screen flex flex-col bg-white">
    {/* Center Section: Just the Brand Name */}
    <div className="flex-1 flex flex-col items-center justify-center">
      <span className="wryven-font text-7xl md:text-8xl text-black tracking-tighter animate-pulse">
        Wryven
      </span>
    </div>

    {/* Bottom Section: Branding */}
    <div className="pb-10 flex flex-col items-center">
      <span className="text-gray-400 text-xs tracking-[0.2em] uppercase mb-1">crafted for writers</span>
    </div>
  </div>
);

export default LoadingSpinner;